import WideSecureLayout from "../../layout/WideSecureLayout.jsx";
import LoadingComponent from "../../components/LoadingComponent.jsx";
import {useTranslation} from "react-i18next";
import useDownloadState from "../../api/utilities/useDownloadState.js";
import ProjectInvitationButton from "./ProjectInvitationButton.jsx";
import {useContext, useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRefresh} from "@fortawesome/free-solid-svg-icons/faRefresh";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import {ProjectApi, ProjectPermission} from "../../api/authority/generated/index";
import FormButton from "../../components/form/FormButton.jsx";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import YesNo from "../../components/YesNo.jsx";
import toast from "react-hot-toast";
import {useErrorTranslation} from "../../api/utilities/translateErrorMessage.js";
import {useHasPermission} from "../../components/auth/rolesAndPermissions.js";
import Button from "../../components/Button.jsx";

export default function ProjectInvitations({project}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let [refresh, setRefresh] = useState(false);
    let [state, setDownloading, setResult, setError] = useDownloadState();

    let {getAuthorityConfiguration} = useContext(GlobalContext);

    let [deletedInviteId, setDeletedInviteId] = useState(null);

    let hasPermission = useHasPermission();

    useEffect(() => {
        setRefresh(false);
        setDownloading(true);

        new ProjectApi(getAuthorityConfiguration())
            .projectInvites({
                projectId: project.id,
            })
            .then(setResult)
            .catch(setError)
            .finally(() => setDownloading(false));


    }, [project.id, refresh]);

    let deleteInvitation = (deletedInviteId) => {
        new ProjectApi(getAuthorityConfiguration())
            .deleteProjectInvite({
                projectId: project.id,
                inviteId: deletedInviteId,
            })
            .then(() => {
                toast.success(t('project.invitation-deleted'));
                setRefresh(true);
            })
            .catch((e) => et(e).then(toast.error))
    };

    return (
        <WideSecureLayout
            title={t('route.project-invitations')}
            actions={<div className={'flex gap-2'}>
                <Button
                    variant={'outline-black'}
                    onClick={() => setRefresh(true)}
                >
                    <FontAwesomeIcon icon={faRefresh}/>
                </Button>
                {
                    hasPermission(ProjectPermission.ProjectInvitations, project) &&
                    <ProjectInvitationButton project={project} onFinally={() => { setRefresh(true); }}/>
                }
            </div>}
        >
            <LoadingComponent loading={state.downloading}>
                {Object.values(state.result ?? []).length === 0 ? <div>{t('project.no-invites-found')}</div> :
                    Object.values(state.result ?? []).map((invite) => {
                        return <div
                            key={invite.id}
                            className="
                                py-1 px-2 bg-white dark:bg-slate-800 rounded-sm border border-slate-200 dark:border-slate-700
                            ">
                            <div className="flex justify-between items-center">
                                <div className="w-5/12">
                                    {invite.email}
                                </div>
                                <div className="w-5/12">
                                    {invite.id}
                                </div>
                                <div className="w-1/12 pb-1">
                                    <FormButton
                                        className={'button button-danger'}
                                        onClick={() => {
                                            setDeletedInviteId(invite.id);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrash}/>
                                    </FormButton>
                                    <YesNo
                                        title={t('confirmation')}
                                        question={t('project.really-delete-invitation-question', {email: invite.email})}
                                        loading={state.downloading}
                                        visible={deletedInviteId === invite.id}
                                        setVisible={(visible) => {
                                            if (visible === false) {
                                                setDeletedInviteId(null);
                                            }
                                        }}
                                        onYes={() => {
                                            deleteInvitation(deletedInviteId);
                                            setDeletedInviteId(null);
                                        }}
                                        onNo={() => setDeletedInviteId(null)}
                                    />
                                </div>
                            </div>
                        </div>;
                    })
                }
            </LoadingComponent>
        </WideSecureLayout>);


}